import React from 'react';
import { Helmet } from 'react-helmet';
import { Typography, Box, Button, Container } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { getCanonicalUrl } from '../utils/canonicalUrl';
import ContactForm from '../components/ContactForm';

export default function Contact() {
  const location = useLocation();
  const canonicalUrl = getCanonicalUrl(location.pathname);
  return (
    <Box sx={{ color: 'common.white' }}>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <title>Contact Robinson Engineering</title>
        <meta name="description" content="Get in touch to discuss your AI engineering needs or schedule a consultation." />
        <meta property="og:title" content="Contact Robinson Engineering" />
        <meta property="og:description" content="Reach out for AI consulting enquiries or to book a call." />
        <meta property="og:image" content="/assets/visuals/re-profile-blue-ai-hud.webp" />
      </Helmet>
      <Box
        sx={{
          position: 'relative',
          backgroundImage:
            'linear-gradient(rgba(24,45,70,0.8), rgba(53,85,111,0.8)), url("/assets/visuals/re-profile-blue-ai-hud.webp")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          textAlign: 'center',
          py: { xs: 8, md: 12 },
        }}
      >
        <Container>
          <Typography variant="h2" component="h1" gutterBottom>
            Contact
          </Typography>
        </Container>
      </Box>
      <Box sx={{ my: 2 }}>
        <Typography variant="h6" gutterBottom>
          Schedule a Call
        </Typography>
        <Button
          variant="outlined"
          color="inherit"
          href="https://calendly.com/example-company/consult"
          target="_blank"
          rel="noopener"
        >
          Book Now
        </Button>
      </Box>
      <ContactForm />
    </Box>
  );
}
